<template>
<div style="width: 800px">
  <div style="margin-bottom: 5px;">
    <el-button size="mini" type="primary" @click="setData">保存</el-button>
  </div>
  <el-descriptions size="mini" :label-style="{width: '100px'}" :column="2" border>
    <el-descriptions-item label="业主编号">
      <el-input size="mini" v-model="form.pid" disabled></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="业主名称">
      <el-input size="mini" v-model="form.name" disabled></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="入伙时间">
      <el-date-picker size="mini" type="date" placeholder="选择日期" v-model="form.join_time" style="width: 100%;"></el-date-picker>
    </el-descriptions-item>
    <el-descriptions-item label="入伙通知书">
      <el-input size="mini" v-model="form.notice_book"></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="业主经办人">
      <el-input size="mini" v-model="form.owner_manager"></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="物业经办人">
      <el-input size="mini" v-model="form.property_manager"></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="销售经办人">
      <el-input size="mini" v-model="form.sales_manager"></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="门禁卡号">
      <el-input size="mini" v-model="form.access_card"></el-input>
    </el-descriptions-item>

    <el-descriptions-item label="备注">
      <el-input size="mini" v-model="form.remark"></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="收房日期">
      <el-date-picker size="mini" type="date" placeholder="选择日期" v-model="form.closing_date" style="width: 100%;"></el-date-picker>
    </el-descriptions-item>
    <el-descriptions-item label="是否收楼">
      <el-select size="mini" v-model="form.is_repossession" placeholder="收楼状态">
        <el-option label="未收楼" :value="0"></el-option>
        <el-option label="已收楼" :value="1"></el-option>
      </el-select>
    </el-descriptions-item>
  </el-descriptions>
</div>
</template>

<script>
export default {
  name: "CustomerAdd",
  data(){
    return{
      form:{}
    }
  },
  props:{
    id:{
      type:Number,
      default(){
        return 0
      }
    }
  },
  mounted() {

  },
  methods:{
    getData(id){
      var that=this;
      ERP.getRequest({url:"admin/CustomerManagement/getRegister",data:{id:id}},ret=>{
        if(ret.code){
          console.log(ret.data)
          that.form=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    setData(){
      var that=this;
      ERP.postRequest({url:"admin/CustomerManagement/setRegister",data:that.form},ret=>{
        if(ret.code){
          this.$msgbox.alert(ret.msg||"修改成功")
        }else{
          this.$msgbox.alert(ret.msg||"修改失败")
        }
      })
    }
  },
  watch:{
    id(n,o){
      if(n){
        this.getData(n);
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@import url(common.scss);
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/CustomerAdd.vue